
import React, { Fragment, useEffect, useState, useRef } from 'react'
import MissionService from '../../../../service/MissionService'
import { useNavigate, useParams } from 'react-router-dom';

import { Accordion, Form } from 'react-bootstrap'
import { Tooltip } from '@mui/material';
import './Validation.css'
import GrafanaPanel from '../TrueTwin_Dashboards/GrafanaPanel';
import CommandCenterService from '../../../../service/CommandCenterService';
import { navigateTo } from '../../../CommonComponents/CommonFunctions';
import Loader from '../../../../Layouts/Loader/Loader';

const ValidationOutPut = () => {
  
  const navigate = useNavigate();
  const params = useParams();

  const {
    mission_name,
    mission_id,
    sat_name,
    sat_id,
    truetwin_name,
    truetwin_id,
    scenario_id,
    validation_name,
    validation_id,
    validation_status
  } = params;

  const scrollRef = useRef(null)

  const [selectedTabBtn, setSelectedTabBtn] = useState<any>('Output');
  const [testPlanData, setTestPlanData] = useState<any>({});
  const [validationData, setValidationData] = useState<any>({});

  const [loading, setLoading] = useState(true);
  const [TrueTwin, setTrueTwin] = useState<any>({});
  const [responseList, setResponseList] = useState<any>([]);
  const [consoleOutputData, setConsoleOutputData] = useState<any>([]);
  const [accordionOpen, setAccordionOpen] = useState<any>([])

  const navigate_to_truetwin_details = () => {
    navigateTo(
        `${mission_name}/${mission_id}/${sat_name}/${sat_id}/truetwin_details/${truetwin_name}/${truetwin_id}/Validation`,
        navigate
    );
}

const getAllTestPlanDetails = () => {
  MissionService.getAllValidationRunsTest(sat_id, truetwin_id)?.then(res => {
    if(res?.data){
        const validation_data = res?.data?.find((item: any) => item?.['uniqueId'] === validation_id);
        get_truetwin_by_id(validation_data);
        setValidationData(validation_data);
      }
      
  }).catch(err => {
      console.log(err);
      setLoading(false);
  })
}

  const get_truetwin_by_id = (validation_data) => {
    CommandCenterService.getTrueTwinStatus(truetwin_id)
      ?.then((res) => {
        if (res?.data) {
          setTrueTwin(res.data);
          getTestPlanDetails(validation_data?.['validationTestId']);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }


  const getTestPlanDetails = (validationTestId) => {
    MissionService.getTestPlanbyId(validationTestId)?.then(res => {
      if(res.data){
        setTestPlanData(res?.data)
        setLoading(false);
      }
    }).catch(err => {
      console.log(err);
      setLoading(false);
    })
  }

  useEffect(() => {
    if(validation_id && validation_id !== undefined){
      getAllTestPlanDetails();
    }
  }, [validation_id])


  useEffect(() => {
    if (consoleOutputData) {
      let d: any[] = [];
      Object.keys(consoleOutputData).map((item, index) => {
        const a = JSON.stringify(consoleOutputData[item], null, 2);
        d[index] =
          `${index % 2 === 0
            ? consoleOutputData[item]["commandTime"]
            : consoleOutputData[item]["ResponseTime"]
          } ` +
          ` ${index % 2 === 0 ? "Telecommand sent" : "Response Received"}` +
          " : " +
          `${a}`;
        setResponseList(d);
      });
    }
  }, [consoleOutputData]);



  useEffect(() => {
    if(Object.keys(validationData).length > 0){
      let check_status = setInterval(() => {
        MissionService.getStatusOfValidationRunsTest(validationData?.["uniqueId"], scenario_id)?.then(resp => {
          const validationData = resp.data?.["result"]
          if (validationData) {
            let outData: any = [];
            validationData.map(data => {
              if (data?.["SequenceData"]){
                const requestObject = {
                  commandData: data?.["SequenceData"],
                  commandTime: data?.["commandTime"],
                }
                outData.push(requestObject)

              } else {
                const responseObj = {
                  commandId: data?.['responseId'],
                  SubmitStatus: data?.["status"],
                  responseData: data?.['responseData'],
                  ResponseTime: data?.['responseTime'],
                };
                outData.push(responseObj)

              }

            })
            setConsoleOutputData(outData);
          }

        }).catch(err => {
          console.log(err);
        })
      }, 3000)

      return () => {
        clearInterval(check_status);
      }
    }
  }, [validationData])

  useEffect(()=>{
    const container = scrollRef.current;
    if (container && accordionOpen?.length === 0) {
      (container as HTMLElement).scrollTop = (container as HTMLElement).scrollHeight;
      (container as HTMLElement).scrollIntoView({ behavior: 'smooth' });
    }
  },[consoleOutputData, accordionOpen])

  const download_console_output = () => {
    var text = responseList;
    var filename = "console_output.txt";
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8, ' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  return (
    <Fragment>
      {loading && <Loader/>}
      <div className='validation__output'>
        <div className='validation__body'>
          {selectedTabBtn === 'Output' &&
            <div className='w-100 fle-1 d-flex gap-5 px-5 pt-5'>
            <div className='w-40'>
              <div className="w-100 d-flex fs-18 justify-content-between align-items-center">
                <div className="form-heade-text mx-1 my-2 fs-20  d-flex gap-2 align-items-center justify-content-center  ">Validation Test Run :
                  <span className='color-atmos fs-16' title={testPlanData?.['title']}>{testPlanData?.['title']?.length > 15 ? testPlanData?.['title']?.substring(0, 15)+"..." : testPlanData?.['title']}</span>
                  <span className='color-atmos-white fs-14'>({testPlanData?.['category']})</span>
                </div>
              </div>
              <div className='d-flex w-100 flex-column gap-3'>
                <div className="d-flex rounded-3 w-100 align-items-center justify-content-between py-4 px-5 border">
                  <span className='d-flex w-90 color-table-header-text fs-16 align-items-center'>TELECOMMAND</span>
                  <span className="d-flex w-10 color-table-header-text fs-16 align-items-center ">DELAY</span>
                </div>
                <div className="telecommand-list-container">
                  {testPlanData?.['teleCommandList']?.map((item,i) => (
                    <details key={i} className={` px-4 py-4`}>
                        <summary className="d-flex rounded-3 w-100 overflow-hidden flex-wrap align-items-center justify-content-between position-relative">
                            <div className="d-flex w-90 align-items-center gap-2">
                                <i className={`fe fe-chevron-right cursor-pointer text-white fs-25`}></i> 
                                <div className='d-flex w-90 flex-column'>
                                    <span className='fs-16 color-atmos-white text-capitalize'>{item?.['commandName']}</span>
                                    <span className='fs-14 color-atmos text-capitalize'>{item?.['commandType'] === 'BUS' ? 'BUS' : item?.['SequenceData']?.['commandData']?.['Sequence_id']}</span>
                                </div>
                            </div>
                            <div className="d-flex w-10 text-center align-items-center justify-content-center text-capitalize">
                                {item?.['delay'] ? item?.['delay'] : 1} sec
                            </div>
                        </summary>
                        <div className='p-3 bg-light-black rounded-2 border mt-2'>
                            <Form.Control className="border-0" disabled type="json" as='textarea' rows={10} value={JSON.stringify(item, null, 4)}/>
                        </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
            <div className="d-flex flex-column flex-1 mt-6">
              <div className="c-output position-relative" ref={scrollRef}>
                <Tooltip title={'Export'} placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        color: "#d8d8d8",
                        backgroundColor: "#0B1422",
                        padding: '8px 20px',
                        fontSize: '14px',
                        borderRadius: '4px',
                        border: '1px solid #0B1422',
                        blur: '15%'
                      }
                    }
                  }}>
                  <button disabled={responseList?.length === 0} className="position-absolute btn btn-outline-primary top-0 end-0 me-3 mt-3 z-1" onClick={download_console_output}> <i className='fe fe-download fs-20'></i> </button>
                </Tooltip>
                  {consoleOutputData?.length > 0 &&
                    Object.keys(consoleOutputData)?.map((item, index1) => {
                      return (
                        <Accordion 
                          activeKey={accordionOpen.includes(item) ? item : ''}
                          onClick={()=>{
                            if(accordionOpen.includes(item)){
                              setAccordionOpen(accordionOpen.filter(i => i !== item))
                            }else{
                              setAccordionOpen([...accordionOpen, item])
                            }
                          }}
                          className="accordion z-0">
                          <Accordion.Item eventKey={item} key={index1}>
                            <Accordion.Header
                              className={
                                index1 % 2 === 0
                                  ? "command"
                                  : consoleOutputData[item]?.['commandId'] === 600 ? ((consoleOutputData[item]?.["SubmitStatus"] === "Success" && consoleOutputData[item]?.['responseData']?.['Num'] === 0) ? "success" : "failed")
                                    : ((consoleOutputData[item]?.['commandId'] !== 600 && consoleOutputData[item]?.["SubmitStatus"] === "Success") ? "success" : "failed")
                              }
                            >
                              <div className="output-response  w-90">
                                <span>{responseList[index1]}</span>
                              </div>{" "}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className='p-3 bg-light-black rounded-2 border mt-2 w-100'>
                                <Form.Control className="border-0" disabled type="json" as='textarea' rows={10} value={JSON.stringify(consoleOutputData[item], null, 4)}/>
                              </div>
                          </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      );
                    })}
              </div>
            </div>
            </div>
          }

          {selectedTabBtn === 'Telemetry' &&
            <div className='w-100 h-100 d-flex'>
              <GrafanaPanel TrueTwin={TrueTwin} validation={validationData} />
            </div>
          }
        </div>

          <div className='validation__footer'>
            <button onClick={navigate_to_truetwin_details} className='d-flex gap-3 align-items-center bg-transparent'>
                <i className='fe fe-chevron-left fs-20 color-text'></i>
                <div className='d-flex flex-column align-items-start'>
                  <span className='fs-18 color-atmos'>{validation_name}</span>
                  <span className='fs-16 color-text'>{validation_status}</span>
                </div>
            </button>
            <div className="d-flex align-items-center footer-btn-list ">
              <button className={selectedTabBtn === 'Output' ? "footer-tab-btn active" : "footer-tab-btn"} type="button" onClick={()=>{setSelectedTabBtn('Output')}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <path d="M2.65 6.646C2.69645 6.59944 2.75162 6.56249 2.81237 6.53729C2.87311 6.51208 2.93823 6.49911 3.004 6.49911C3.06977 6.49911 3.13489 6.51208 3.19563 6.53729C3.25638 6.56249 3.31155 6.59944 3.358 6.646L5.358 8.646C5.40456 8.69245 5.44151 8.74762 5.46671 8.80837C5.49192 8.86911 5.50489 8.93423 5.50489 9C5.50489 9.06577 5.49192 9.13089 5.46671 9.19163C5.44151 9.25238 5.40456 9.30755 5.358 9.354L3.358 11.354C3.31151 11.4005 3.25632 11.4374 3.19558 11.4625C3.13484 11.4877 3.06974 11.5006 3.004 11.5006C2.93826 11.5006 2.87316 11.4877 2.81242 11.4625C2.75168 11.4374 2.69649 11.4005 2.65 11.354C2.60351 11.3075 2.56664 11.2523 2.54148 11.1916C2.51632 11.1308 2.50337 11.0657 2.50337 11C2.50337 10.9343 2.51632 10.8692 2.54148 10.8084C2.56664 10.7477 2.60351 10.6925 2.65 10.646L4.297 9L2.65 7.354C2.60344 7.30755 2.56649 7.25238 2.54129 7.19163C2.51608 7.13089 2.50311 7.06577 2.50311 7C2.50311 6.93423 2.51608 6.86911 2.54129 6.80837C2.56649 6.74762 2.60344 6.69245 2.65 6.646ZM11.504 10.5H6.504C6.37139 10.5 6.24421 10.5527 6.15045 10.6464C6.05668 10.7402 6.004 10.8674 6.004 11C6.004 11.1326 6.05668 11.2598 6.15045 11.3536C6.24421 11.4473 6.37139 11.5 6.504 11.5H11.504C11.6366 11.5 11.7638 11.4473 11.8576 11.3536C11.9513 11.2598 12.004 11.1326 12.004 11C12.004 10.8674 11.9513 10.7402 11.8576 10.6464C11.7638 10.5527 11.6366 10.5 11.504 10.5ZM0 3C0 2.33696 0.263392 1.70107 0.732233 1.23223C1.20107 0.763392 1.83696 0.5 2.5 0.5H11.5C12.163 0.5 12.7989 0.763392 13.2678 1.23223C13.7366 1.70107 14 2.33696 14 3V3.5H14.004V4.5H14.001V12C14.001 12.663 13.7376 13.2989 13.2688 13.7678C12.7999 14.2366 12.164 14.5 11.501 14.5H2.501C1.83796 14.5 1.20207 14.2366 0.733233 13.7678C0.264392 13.2989 0.000999928 12.663 0.000999928 12L0 3ZM13 3.5V3C13 2.60218 12.842 2.22064 12.5607 1.93934C12.2794 1.65804 11.8978 1.5 11.5 1.5H2.5C2.10217 1.5 1.72064 1.65804 1.43934 1.93934C1.15804 2.22064 1 2.60218 1 3V3.5H13ZM1 4.5V12C1 12.3978 1.15804 12.7794 1.43934 13.0607C1.72064 13.342 2.10217 13.5 2.5 13.5H11.5C11.8978 13.5 12.2794 13.342 12.5607 13.0607C12.842 12.7794 13 12.3978 13 12V4.5H1Z" fill={selectedTabBtn === 'Output' ? "#000000" : "#DDDDDD"} />
                  </svg>
                  <span>Output</span>
              </button>
              <button className={selectedTabBtn === 'Telemetry' ? "footer-tab-btn active" : "footer-tab-btn"} type="button" onClick={()=>{setSelectedTabBtn('Telemetry')}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                      <path d="M8.00391 0C6.42166 0 4.87494 0.469192 3.55935 1.34824C2.24375 2.22729 1.21837 3.47672 0.612873 4.93853C0.00737253 6.40034 -0.151054 8.00887 0.157628 9.56072C0.466309 11.1126 1.22824 12.538 2.34705 13.6569C3.46587 14.7757 4.89134 15.5376 6.44319 15.8463C7.99503 16.155 9.60357 15.9965 11.0654 15.391C12.5272 14.7855 13.7766 13.7602 14.6557 12.4446C15.5347 11.129 16.0039 9.58225 16.0039 8C16.0017 5.87895 15.1581 3.84542 13.6583 2.34562C12.1585 0.845814 10.125 0.00223986 8.00391 0ZM6.13848 11.5853C6.05049 11.3334 6.24252 11.0769 6.50936 11.0769H9.49845C9.76529 11.0769 9.95733 11.3334 9.86933 11.5853C9.4983 12.6475 8.96414 13.6171 8.2892 14.4338C8.1403 14.614 7.86752 14.614 7.71861 14.4338C7.04367 13.6171 6.50952 12.6475 6.13848 11.5853ZM6.03496 9.84615C5.83947 9.84615 5.67184 9.70494 5.64548 9.51124C5.50903 8.50837 5.50903 7.49163 5.64548 6.48876C5.67184 6.29505 5.83947 6.15384 6.03496 6.15384H9.97285C10.1683 6.15384 10.336 6.29506 10.3623 6.48876C10.4988 7.49163 10.4988 8.50837 10.3623 9.51124C10.336 9.70494 10.1683 9.84615 9.97285 9.84615H6.03496ZM1.23468 8C1.23423 7.47654 1.29477 6.95516 1.41484 6.44637C1.45591 6.2723 1.61424 6.15384 1.79309 6.15384H3.98482C4.22937 6.15384 4.41621 6.37133 4.38898 6.61436C4.28581 7.53523 4.28581 8.46476 4.38898 9.38563C4.41621 9.62866 4.22937 9.84615 3.98482 9.84615H1.79309C1.61424 9.84615 1.45591 9.72769 1.41484 9.55363C1.29477 9.04483 1.23423 8.52345 1.23468 8ZM9.86933 4.4147C9.95733 4.66662 9.76529 4.92308 9.49845 4.92308H6.50936C6.24252 4.92308 6.05049 4.66662 6.13848 4.4147C6.50952 3.35251 7.04367 2.38291 7.71861 1.56617C7.86752 1.38599 8.1403 1.38599 8.2892 1.56617C8.96414 2.38291 9.4983 3.35251 9.86933 4.4147ZM11.6188 6.61436C11.5916 6.37133 11.7785 6.15384 12.023 6.15384H14.2145C14.3934 6.15384 14.5518 6.27249 14.5928 6.4467C14.8332 7.46824 14.8332 8.53176 14.5928 9.5533C14.5518 9.72751 14.3934 9.84615 14.2145 9.84615H12.023C11.7785 9.84615 11.5916 9.62866 11.6188 9.38563C11.722 8.46476 11.722 7.53523 11.6188 6.61436ZM13.7059 4.35575C13.8674 4.60756 13.6767 4.92308 13.3775 4.92308H11.618C11.4351 4.92308 11.2762 4.7987 11.2261 4.62272C11.0042 3.84304 10.6967 3.09116 10.3096 2.38069C10.1321 2.055 10.4239 1.67065 10.7624 1.82222C11.2967 2.06143 11.7991 2.36926 12.2567 2.73902C12.8244 3.1977 13.3133 3.74387 13.7059 4.35575ZM5.24537 1.82222C5.58387 1.67065 5.87568 2.055 5.69824 2.38069C5.31116 3.09116 5.00361 3.84304 4.78172 4.62272C4.73164 4.7987 4.57274 4.92308 4.38977 4.92308H2.63027C2.33109 4.92308 2.14042 4.60756 2.30196 4.35575C2.69451 3.74387 3.18346 3.1977 3.7511 2.73902C4.2087 2.36926 4.71116 2.06143 5.24537 1.82222ZM2.30196 11.6442C2.14042 11.3924 2.33109 11.0769 2.63027 11.0769H4.38977C4.57274 11.0769 4.73164 11.2013 4.78172 11.3773C5.00361 12.157 5.31116 12.9088 5.69824 13.6193C5.87568 13.945 5.58387 14.3293 5.24537 14.1778C4.71116 13.9386 4.2087 13.6307 3.7511 13.261C3.18346 12.8023 2.69451 12.2561 2.30196 11.6442ZM10.7624 14.1778C10.4239 14.3293 10.1321 13.945 10.3096 13.6193C10.6967 12.9088 11.0042 12.157 11.2261 11.3773C11.2762 11.2013 11.4351 11.0769 11.618 11.0769H13.3775C13.6767 11.0769 13.8674 11.3924 13.7059 11.6442C13.3133 12.2561 12.8244 12.8023 12.2567 13.261C11.7991 13.6307 11.2967 13.9386 10.7624 14.1778Z" fill={selectedTabBtn === 'Telemetry' ? "#000000" : "#DDDDDD"} />
                  </svg>
                  <span>Telemetry</span>
              </button>
            </div>
            <button className='btn btn-outline-primary ps-7 pe-7 ' onClick={navigate_to_truetwin_details}>Close</button> 
          </div>
      </div>
    </Fragment>
  )
}

export default ValidationOutPut